import * as React from 'react'
import { I18nService } from '../../../../services/utils/i18n.service'
import CheckboxComponent from '../../../shared/checkbox.component'
import { OfferedServiceBase } from '../../../../services/json-schemas/base/offered_service'
import { SpecificIncreaseBase } from '../../../../services/json-schemas/base/specific_increase'
import TooltipComponent from '../../../shared/tooltip.component'

type Props = {
  checked: boolean
  onChange: (checked: boolean) => void
  offeredService: Pick<OfferedServiceBase, 'specific_pricing_mode'> & { specific_increases: Pick<SpecificIncreaseBase, 'id' | 'name' | 'percentage'>[] }
  className?: string
}

const i18nScoped = new I18nService(require('./quotation-use-specific-increases-checkbox.component.yml'))

export default function QuotationUseSpecificIncreasesCheckboxComponent ({ checked, onChange, offeredService, className }: Props) {
  if (offeredService.specific_pricing_mode !== 'specific_increase' || !offeredService.specific_increases.length) return null

  const title = i18nScoped.t('set_specific_increases')
  const message = offeredService.specific_increases.map(sp => `${sp.name} : ${sp.percentage > 0 ? '+' : ''}${sp.percentage}%`)

  return <TooltipComponent className={ className } title={ title } message={ message }>
    <CheckboxComponent
      id="use_specific_increases"
      checked={ checked }
      onChange={ onChange }
      label={ i18nScoped.t('use_specific_increases') } />
  </TooltipComponent>
}
